// Configuración de permisos (extraído de Users.js para reducir tamaño del archivo)
import { TrendingUp, ShoppingCart, Package, HeartPulse, Wallet, BarChart3, Home, BookText, SlidersHorizontal } from 'lucide-react';

// Agrupamiento de los módulos para el panel de Permisos. Refleja la estructura
// del sidebar: Tablero / Compras / Stock / Enfermería / Tesorería / Análisis / Configuración.
export const PERMISSION_GROUPS = [
  { id: 'tablero',       label: 'Tablero',              icon: TrendingUp,    color: 'sky',     keys: ['dashboard'] },
  { id: 'compras',       label: 'Compras',              icon: ShoppingCart,  color: 'indigo',  keys: ['proveedores', 'proveedores_cc', 'notas_pedido', 'demanda_insatisfecha', 'ordenes_compra', 'recepciones', 'compras_otras'] },
  { id: 'stock',         label: 'Stock y Movimientos',  icon: Package,       color: 'amber',   keys: ['depositos', 'movimiento_interno', 'transferencias_deposito', 'conteo_fisico'] },
  { id: 'enfermeria',    label: 'Enfermería',           icon: HeartPulse,    color: 'rose',    keys: ['pedidos_internos', 'recepciones_internas', 'conteo_fisico_area'] },
  { id: 'tesoreria',     label: 'Tesorería',            icon: Wallet,        color: 'emerald', keys: [
    'tesoreria_panel',
    'tesoreria_config', 'tesoreria_cobranzas', 'tesoreria_pagos', 'tesoreria_transferencias',
    'tesoreria_ajustes', 'tesoreria_valores', 'tesoreria_arqueos', 'tesoreria_conciliaciones',
    'tesoreria_libro', 'tesoreria_reportes',
  ] },
  { id: 'analisis',      label: 'Análisis',             icon: BarChart3,     color: 'violet',  keys: ['reportes'] },
  { id: 'residentes',    label: 'Residentes',           icon: Home,          color: 'teal',    keys: ['residentes', 'servicios_residentes', 'deudores'] },
  { id: 'contabilidad',  label: 'Contabilidad',         icon: BookText,      color: 'cyan',    keys: ['contabilidad', 'contabilidad_iva'] },
  { id: 'configuracion', label: 'Configuración',        icon: SlidersHorizontal, color: 'slate', keys: ['articulos', 'usuarios', 'auditoria', 'exportaciones'] },
];

// Paleta por color (Tailwind safelist) — usamos clases full así Tailwind las incluye.
export const GROUP_COLORS = {
  sky:     { bg: 'bg-sky-50 dark:bg-sky-950/30',         text: 'text-sky-700 dark:text-sky-300',         ring: 'ring-sky-200 dark:ring-sky-800',         icon: 'text-sky-600 dark:text-sky-400',         border: 'border-sky-200 dark:border-sky-800' },
  indigo:  { bg: 'bg-indigo-50 dark:bg-indigo-950/30',   text: 'text-indigo-700 dark:text-indigo-300',   ring: 'ring-indigo-200 dark:ring-indigo-800',   icon: 'text-indigo-600 dark:text-indigo-400',   border: 'border-indigo-200 dark:border-indigo-800' },
  amber:   { bg: 'bg-amber-50 dark:bg-amber-950/30',     text: 'text-amber-800 dark:text-amber-300',     ring: 'ring-amber-200 dark:ring-amber-800',     icon: 'text-amber-600 dark:text-amber-400',     border: 'border-amber-200 dark:border-amber-800' },
  rose:    { bg: 'bg-rose-50 dark:bg-rose-950/30',       text: 'text-rose-700 dark:text-rose-300',       ring: 'ring-rose-200 dark:ring-rose-800',       icon: 'text-rose-600 dark:text-rose-400',       border: 'border-rose-200 dark:border-rose-800' },
  emerald: { bg: 'bg-emerald-50 dark:bg-emerald-950/30', text: 'text-emerald-700 dark:text-emerald-300', ring: 'ring-emerald-200 dark:ring-emerald-800', icon: 'text-emerald-600 dark:text-emerald-400', border: 'border-emerald-200 dark:border-emerald-800' },
  violet:  { bg: 'bg-violet-50 dark:bg-violet-950/30',   text: 'text-violet-700 dark:text-violet-300',   ring: 'ring-violet-200 dark:ring-violet-800',   icon: 'text-violet-600 dark:text-violet-400',   border: 'border-violet-200 dark:border-violet-800' },
  teal:    { bg: 'bg-teal-50 dark:bg-teal-950/30',       text: 'text-teal-700 dark:text-teal-300',       ring: 'ring-teal-200 dark:ring-teal-800',       icon: 'text-teal-600 dark:text-teal-400',       border: 'border-teal-200 dark:border-teal-800' },
  cyan:    { bg: 'bg-cyan-50 dark:bg-cyan-950/30',       text: 'text-cyan-700 dark:text-cyan-300',       ring: 'ring-cyan-200 dark:ring-cyan-800',       icon: 'text-cyan-600 dark:text-cyan-400',       border: 'border-cyan-200 dark:border-cyan-800' },
  slate:   { bg: 'bg-slate-100 dark:bg-slate-900/50',    text: 'text-slate-700 dark:text-slate-300',     ring: 'ring-slate-200 dark:ring-slate-700',     icon: 'text-slate-600 dark:text-slate-400',     border: 'border-slate-200 dark:border-slate-700' },
};

// Estructura de permisos para el UI
export const PERMISSION_MODULES = [
  { 
    key: 'dashboard', 
    label: 'Tablero - Visualizaciones', 
    permissions: [
      { key: 'ver', label: 'Acceso al Tablero' },
      // --- Widgets legacy (compatibilidad) ---
      { key: 'resumen_general', label: 'Resumen General (Totales)' },
      { key: 'valor_inventario', label: 'Valor de Inventario' },
      { key: 'stock_bajo', label: 'Alertas de Stock Bajo' },
      { key: 'np_pendientes', label: 'NP Pendientes' },
      { key: 'oc_pendientes', label: 'OC Pendientes de Recepción' },
      { key: 'recepciones_condicionales', label: 'Recepciones Condicionales' },
      { key: 'movimientos_dia', label: 'Movimientos del Día' },
      { key: 'actividad_reciente', label: 'Actividad Reciente (Auditoría)' },
      { key: 'grafico_stock_deposito', label: 'Gráfico: Stock por Depósito' },
      { key: 'grafico_movimientos', label: 'Gráfico: Movimientos Mensual' },
      { key: 'vencimientos_proximos', label: 'Vencimientos Próximos (Lotes)' },
      // --- Tablero V2: 21 widgets nuevos ---
      { key: 'alertas_criticas', label: '🔴 Bloque 1 — Alertas Críticas' },
      { key: 'inv_valor_total', label: '📦 Bloque 2 — Valor Total Stock (variación)' },
      { key: 'inv_vencimientos_heatmap', label: '📦 Bloque 2 — Heatmap Vencimientos por Depósito' },
      { key: 'inv_top_criticos', label: '📦 Bloque 2 — Top Críticos (Stock ≤ Reposición)' },
      { key: 'inv_pareto', label: '📦 Bloque 2 — Pareto 80% del Inventario' },
      { key: 'flujo_embudo', label: '🛒 Bloque 3 — Embudo NP → OC → Recepción' },
      { key: 'flujo_lead_time', label: '🛒 Bloque 3 — Lead Time Compras (días)' },
      { key: 'flujo_demanda_insatisfecha', label: '🛒 Bloque 3 — Demanda Insatisfecha' },
      { key: 'flujo_top_proveedores', label: '🛒 Bloque 3 — Top Proveedores del Mes' },
      { key: 'opi_pendientes', label: '🏥 Bloque 4 — OPI Pendientes' },
      { key: 'opi_faltante_pct', label: '🏥 Bloque 4 — % OPI con Faltante (30d)' },
      { key: 'opi_top_areas', label: '🏥 Bloque 4 — Top Áreas Consumidoras' },
      { key: 'opi_rem_mes', label: '🏥 Bloque 4 — REM del Mes (Familiares)' },
      { key: 'tes_saldo_consolidado', label: '💰 Bloque 5 — Saldo Consolidado por Moneda' },
      { key: 'tes_cheques_propios', label: '💰 Bloque 5 — Cheques por Vencer (7/15/30d)' },
      { key: 'tes_cheques_terceros', label: '💰 Bloque 5 — Cheques en Cartera por Estado' },
      { key: 'tes_top_conceptos', label: '💰 Bloque 5 — Top Conceptos Ingreso/Egreso' },
      { key: 'tes_op_pendientes', label: '💰 Bloque 5 — Órdenes de Pago del Mes' },
      { key: 'act_top_usuarios', label: '👥 Bloque 6 — Top Usuarios Activos (Admin)' },
      { key: 'act_audit_critico', label: '👥 Bloque 6 — Actividad Crítica (Admin)' },
      { key: 'act_compras_12m', label: '👥 Bloque 6 — Compras Últimos 12 Meses (Admin)' }
    ]
  },
  { 
    key: 'depositos', 
    label: 'Depósitos', 
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Editar' },
      { key: 'eliminar', label: 'Eliminar' }
    ]
  },
  { 
    key: 'articulos', 
    label: 'Artículos', 
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Editar' },
      { key: 'eliminar', label: 'Eliminar' },
      { key: 'estabilizar', label: 'Homologación & Fusión (ver y operar la pestaña)' }
    ]
  },
  { 
    key: 'movimiento_interno', 
    label: 'Movimiento Interno', 
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'entrada', label: 'Crear Entradas' },
      { key: 'salida', label: 'Crear Salidas' },
      { key: 'eliminar', label: 'Eliminar movimiento (revierte stock)' }
    ]
  },
  {
    key: 'transferencias_deposito',
    label: 'Transferencias entre Depósitos',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'enviar', label: 'Enviar (descarga origen)' },
      { key: 'recibir', label: 'Recibir (ingresa destino)' }
    ]
  },
  {
    key: 'conteo_fisico',
    label: 'Conteo Físico de Stock',
    permissions: [
      { key: 'ver', label: 'Ver conteos y diferencias' },
      { key: 'crear', label: 'Abrir conteo y cargar cantidades' },
      { key: 'finalizar', label: 'Finalizar conteo (congela el reporte)' },
      { key: 'ajustar', label: 'Generar ajuste de stock (mueve stock real)' },
      { key: 'eliminar', label: 'Eliminar la hoja de conteo (no revierte stock)' }
    ]
  },
  {
    key: 'conteo_fisico_area',
    label: 'Arqueo del Área (Enfermería)',
    permissions: [
      { key: 'ver', label: 'Ver los arqueos de sus áreas' },
      { key: 'crear', label: 'Abrir arqueo y cargar cantidades' },
      { key: 'finalizar', label: 'Finalizar arqueo (congela el reporte)' },
      { key: 'eliminar', label: 'Eliminar la hoja de arqueo propio del área' }
    ]
  },
  { 
    key: 'notas_pedido', 
    label: 'Notas de Pedido',  
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'aprobar', label: 'Aprobar' },
      { key: 'rechazar', label: 'Rechazar' },
      { key: 'eliminar', label: 'Eliminar (solo NP sin OC)' }
    ]
  },
  { 
    key: 'ordenes_compra', 
    label: 'Órdenes de Compra', 
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Editar' },
      { key: 'aprobar', label: 'Aprobar' },
      { key: 'rechazar', label: 'Rechazar' }
    ]
  },
  { 
    key: 'recepciones', 
    label: 'Recepciones', 
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Editar' },
      { key: 'aprobar', label: 'Aprobar' },
      { key: 'rechazar', label: 'Rechazar' },
      { key: 'comprobantes', label: 'Cargar Comprobante Fiscal (datos impositivos)' }
    ]
  },
  {
    key: 'compras_otras',
    label: 'Otras Compras',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'eliminar', label: 'Eliminar FC (no paga)' }
    ]
  },
  { 
    key: 'proveedores', 
    label: 'Proveedores', 
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Editar' },
      { key: 'eliminar', label: 'Eliminar' }
    ]
  },
  {
    key: 'proveedores_cc',
    label: 'Cta. Corriente de Proveedores',
    permissions: [
      { key: 'ver', label: 'Ver' }
    ]
  },
  { 
    key: 'pedidos_internos', 
    label: 'Pedidos Internos (Enfermería)', 
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Editar' },
      { key: 'aprobar', label: 'Aprobar' },
      { key: 'rechazar', label: 'Rechazar' },
      { key: 'despachar', label: 'Despachar (total / parcial)' },
      { key: 'recibir', label: 'Recibir en el área (confirmar recepción)' },
      { key: 'cerrar_con_pendiente', label: 'Cerrar OPI con saldo pendiente' },
      { key: 'devolver', label: 'Devolver' },
      { key: 'consumir', label: 'Consumir' },
      { key: 'eliminar', label: 'Eliminar (sólo no aprobados)' }
    ]
  },
  {
    key: 'recepciones_internas',
    label: 'Recepciones Externas (REM) - Medicación de Familiares',
    permissions: [
      { key: 'ver', label: 'Ver listado y detalle' },
      { key: 'crear', label: 'Registrar nueva recepción' },
      { key: 'crear_articulo_nuevo', label: 'Dar de alta medicamentos nuevos al cargar REM' },
      { key: 'eliminar', label: 'Eliminar REM (revierte stock)' }
    ]
  },
  {
    key: 'demanda_insatisfecha',
    label: 'Demanda Insatisfecha (Compras)',
    permissions: [
      { key: 'ver', label: 'Ver listado de faltantes' },
      { key: 'generar_np', label: 'Generar NP desde un faltante' }
    ]
  },
  { 
    key: 'reportes', 
    label: 'Reportes', 
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'generar', label: 'Generar' }
    ]
  },
  { 
    key: 'usuarios', 
    label: 'Usuarios', 
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'editar', label: 'Editar' }
    ]
  },
  { 
    key: 'exportaciones', 
    label: 'Exportaciones', 
    permissions: [{ key: 'excel', label: 'Exportar Excel' }]
  },
  { 
    key: 'auditoria', 
    label: 'Auditoría', 
    permissions: [{ key: 'ver', label: 'Ver' }]
  },
  // ============== TESORERÍA (11 sub-módulos) ==============
  {
    key: 'tesoreria_panel',
    label: 'Panel de Tesorería (saldos y estadísticas)',
    permissions: [
      { key: 'ver', label: 'Ver Panel (saldos de cajas/bancos, estadísticas y últimos movimientos)' },
    ],
  },
  {
    key: 'tesoreria_config',
    label: 'Configuración (Cajas/Bancos, Conceptos, Tipos de Valor)',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Editar' },
      { key: 'eliminar', label: 'Eliminar' },
    ],
  },
  {
    key: 'tesoreria_cobranzas',
    label: 'Cobranzas',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Editar' },
      { key: 'anular', label: 'Anular' },
      { key: 'eliminar', label: 'Eliminar cobranza (reversa todo)' },
    ],
  },
  {
    key: 'tesoreria_pagos',
    label: 'Órdenes de Pago',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Editar' },
      { key: 'aprobar', label: 'Aprobar' },
      { key: 'anular', label: 'Anular' },
      { key: 'eliminar', label: 'Eliminar OP (reversa todo)' },
      { key: 'anular_rendicion', label: 'Anular rendición de anticipo' },
    ],
  },
  {
    key: 'tesoreria_transferencias',
    label: 'Transferencias entre Cajas',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'anular', label: 'Anular' },
      { key: 'eliminar', label: 'Eliminar transferencia (reversa todo)' },
    ],
  },
  {
    key: 'tesoreria_ajustes',
    label: 'Ajustes manuales',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'anular', label: 'Anular' },
      { key: 'eliminar', label: 'Eliminar ajuste (reversa todo)' },
    ],
  },
  {
    key: 'tesoreria_valores',
    label: 'Valores (Cheques)',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Editar' },
      { key: 'anular', label: 'Anular' },
    ],
  },
  {
    key: 'tesoreria_arqueos',
    label: 'Arqueos de Caja',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'editar', label: 'Cerrar arqueo, agregar/eliminar ajustes' },
      { key: 'reabrir', label: 'Reabrir arqueo cerrado (libera bloqueo bancario)' },
    ],
  },
  {
    key: 'tesoreria_conciliaciones',
    label: 'Conciliaciones Bancarias',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'crear', label: 'Crear' },
      { key: 'conciliar', label: 'Conciliar (marcar movimientos, agregar bancarios y completar)' },
      { key: 'reabrir', label: 'Reabrir conciliación completada (libera bloqueo bancario)' },
    ],
  },
  {
    key: 'tesoreria_libro',
    label: 'Libro de Movimientos',
    permissions: [
      { key: 'ver', label: 'Ver' },
    ],
  },
  {
    key: 'tesoreria_reportes',
    label: 'Reportes',
    permissions: [
      { key: 'ver', label: 'Ver' },
      { key: 'generar', label: 'Generar' },
    ],
  },
  // ============== RESIDENTES (módulo nuevo Fase 1A/1B) ==============
  {
    key: 'residentes',
    label: 'Residentes · Fichas',
    permissions: [
      { key: 'ver', label: 'Ver listado y ficha' },
      { key: 'crear', label: 'Crear residente' },
      { key: 'editar', label: 'Editar (datos, fiscal, responsables, archivar)' },
      { key: 'dar_baja', label: 'Dar de baja / Eliminar' },
    ],
  },
  {
    key: 'servicios_residentes',
    label: 'Residentes · Catálogo de Servicios y Abonos',
    permissions: [
      { key: 'ver', label: 'Ver catálogo' },
      { key: 'crear', label: 'Crear servicio' },
      { key: 'editar', label: 'Editar servicio' },
      { key: 'eliminar', label: 'Eliminar / desactivar' },
      { key: 'actualizar_precios', label: 'Actualizar precios masivos' },
    ],
  },
  // ============== DEUDORES POR VENTAS ==============
  {
    key: 'deudores',
    label: 'Deudores por Ventas · Aging unificado',
    permissions: [
      { key: 'ver', label: 'Ver listado de deudores (residentes + responsables + OS)' },
      { key: 'exportar', label: 'Descargar PDF / Excel del aging' },
    ],
  },
  // ============== CONTABILIDAD (Fase 2) ==============
  {
    key: 'contabilidad',
    label: 'Contabilidad · Plan de Cuentas, Diario, Mayor',
    permissions: [
      { key: 'ver', label: 'Ver plan de cuentas, libro diario, mayor y balances' },
      { key: 'crear', label: 'Crear cuentas / asientos manuales / importar Excel' },
      { key: 'editar', label: 'Editar cuentas y mapeos' },
      { key: 'eliminar', label: 'Borrar cuentas y mapeos' },
    ],
  },
  {
    key: 'contabilidad_iva',
    label: 'Contabilidad · Libros IVA (Ventas y Compras)',
    permissions: [
      { key: 'ver', label: 'Ver Libros IVA Ventas y Compras' },
      { key: 'exportar', label: 'Exportar a Excel / PDF' },
    ],
  },
];
